export default __webpack_public_path__ + "static/media/pho.46f5c9da.webp";